lmApp
  .controller('PackageController', ['$scope', '$rootScope', '$timeout', '$templateCache', '$compile', '$q', '$routeParams', '$location', 'AssetService', 'ModalWindowService', 'MetadataService', 'PackageService', 'ToastService', 'ManageAssetsWindow', 'GroupService', 'OfferService', 'PlanService', 'ModalConfirmService', 'AssetResource', 'GroupResource', 'CategoryResource', 'SubscriptionPlanResource',
    function ($scope, $rootScope, $timeout, $templateCache, $compile, $q, $routeParams, $location, AssetService, ModalWindowService, MetadataService, PackageService, ToastService, ManageAssetsWindow, GroupService, OfferService, PlanService, ModalConfirmService, AssetResource, GroupResource, CategoryResource, SubscriptionPlanResource) {
      $scope.loading = false;
      $scope.packageCollection = [];
      $scope.offerSearch = [];
      $scope.groupSearch = [];
      $scope.categorySearch = [];

      $scope.categories = [];
      $scope.groups = [];
      $scope.plans = [];

      var savedPlans = {};

      var getFilterData = function () {
        GroupResource.get().$promise
            .then(function (groups) {
              var groupList = [];
              for (var i = 0; i < groups.length; i++) {
                var group = groups[i];
                groupList.push({
                  id: group.id,
                  title: group.name
                });
              }
              $scope.groups = groupList;
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason);
            });

        CategoryResource.get().$promise
            .then(function (categories) {
              var categoryList = [];
              for (var i = 0; i < categories.length; i++) {
                var category = categories[i];
                categoryList.push({
                  id: category.id,
                  title: category.name
                });
              }
              $scope.categories = categoryList;
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason);
            });
      };

      getFilterData();

      /////////
      $scope.assets = [];

      var processCategory = function(category) {
        return {
          id: category.id,
          title: category.name
        };
      };

      var processGroup = function(group) {
        return {
          id: group.id,
          title: group.name
        };
      };

      var processAsset = function(asset) {
        var processed = {
          id: asset.id,
          extid: asset.ext_id,
          description: asset.description,
          createTime: asset.create_time,
          updateTime: asset.update_time,
          name: asset.name,
          rotationStart: moment(asset.rotation_start),
          rotationFinish: moment(asset.rotation_finish),
          categories: [],
          poster: {
            state: '',
            url: '',
            source: ''
          },
          rotationPeriodOK: true,
          free: false,
          conditions: {
            ready: processCondition({})
          },
          groups: [],
          billingType: 'free', // free, plans
          plans: [],
          _PrivateData: {}
        };

        if (asset.free) {
          processed.free = true;
          processed.billingType = 'free';
        }

        if (moment(asset.rotation_start).diff(moment()) > 0 || moment(asset.rotation_finish).diff(moment()) < 0) {
          processed.rotationPeriodOK = false;
        }

        if (asset.resources) {
          var posters = asset.resources.filter(function (resource) {
            return resource.type === 'picture';
          });
          if (posters.length > 0) {
            processed.poster.state = posters[0].state;
            processed.poster.url = posters[0].url;
            processed.poster.source = posters[0].source;
          }
        }

        if (asset.groups) {
          processed.groups = asset.groups.map(processGroup);
        }
        if (asset.categories) {
          processed.categories = asset.categories.map(processCategory);
        }

        processed._PrivateData.offset = 0;
        processed._PrivateData.limit = 30;
        processed._PrivateData.selectedAsset = [];
        processed._PrivateData.packageAssets = [];

        return processed;
      };

      var processCondition = function (condition) {
        return {
          id: condition.id || 0,
          required: condition.required || false,
          type: condition.type || '',
          state: condition.state || ''
        }
      };

      $scope.getPackages2 = function () {
        if ($scope.loading) return;
        $scope.loading = true;
        $rootScope.showLinearProgress('#packageLoader');

        var params = {};
        params['$limit'] = 1000;
        params['$offset'] = 0;
        params['type[in]'] = 'package';
        params['$expand'] = 'groups,conditions';

        AssetResource.get(params).$promise
            .then(function (assets) {
              var processed = [];
              for (var i = 0; i < assets.length; i++) {
                var asset = assets[i];
                processed.push(processAsset(asset));
              }
              $scope.assets = processed;
            })
            .catch(function (reason) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#packageLoader');
              ToastService.Small({
                title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                color: 'amber',
                icon: 'server-off',
                blocked: true
              }, 1000 * 3);
              $rootScope.debugInfo(reason, 'silent');
            })
      };

      // $scope.getPackages();
      /////////



      $rootScope.EVENTS = _.extend($rootScope.EVENTS, {UPDATE_PACKAGE_COLLECTION: 'update.package.collection'});

      $scope.search = {
        isShown: false,
        searchField: ''
      };

      $scope.activePackage = {};

      $scope.isActivePackageSet = function () {
        return !_.isEmpty($scope.activePackage);
      };

      var _parsePackage = function (pkg, index) {
        pkg._PrivateData = {};
        pkg._PrivateData.index = index;
        pkg._PrivateData.id = pkg.id;

        pkg._PrivateData.offset = 0;
        pkg._PrivateData.limit = 30;

        if (!pkg.assets) pkg.assets = [];
        pkg._PrivateData.title = pkg.title;
        pkg._PrivateData.description = pkg.description;
        pkg._PrivateData.selectedAsset = [];
        pkg._PrivateData.groupsOld = [];
        pkg._PrivateData.groupsNew = [];
        pkg._PrivateData.categoriesOld = [];
        pkg._PrivateData.categoriesNew = [];
        pkg._PrivateData.offersOld = [];
        pkg._PrivateData.offersNew = [];
        pkg._PrivateData.tagsOld = pkg.tags;
        pkg._PrivateData.tagsNew = pkg._PrivateData.tagsOld;

        pkg._PrivateData.rotation_start = pkg.rotation_start ? moment.utc(pkg.rotation_start * 1000) : moment.utc();
        pkg._PrivateData.rotation_finish = pkg.rotation_finish ? moment.utc(pkg.rotation_finish * 1000) : moment.utc();

        pkg._PrivateData.license_start = pkg.license_start ? moment.utc(pkg.license_start * 1000) : moment.utc();
        pkg._PrivateData.license_finish = pkg.license_finish ? moment.utc(pkg.license_finish * 1000) : moment.utc();

        pkg._PrivateData.platformsOld = MetadataService.Platforms.GetAvailablePlatforms(pkg, $rootScope.platforms);
        pkg._PrivateData.platformsNew = angular.copy(pkg._PrivateData.platformsOld);

        return pkg;
      };

      $scope.nextPage = function () {
        if ($scope.activePackage._PrivateData.offset + $scope.activePackage._PrivateData.limit < $scope.activePackage._PrivateData.assets.length) {
          $scope.activePackage._PrivateData.offset = $scope.activePackage._PrivateData.offset + $scope.activePackage._PrivateData.limit;
        }
      };

      $scope.prevPage = function () {
        $scope.activePackage._PrivateData.offset = Math.max($scope.activePackage._PrivateData.offset - $scope.activePackage._PrivateData.limit, 0);
      };

      $scope.assetToSelection = function (asset) {
        var index = $scope.activePackage._PrivateData.selectedAsset.indexOf(asset);

        if (index !== -1) {
          $scope.activePackage._PrivateData.selectedAsset.splice(index, 1);
        } else {
          $scope.activePackage._PrivateData.selectedAsset.push(asset);
        }
      };

      $scope.toggleSearch = function () {
        $scope.search.isShown = !$scope.search.isShown;

        if ($scope.search.isShown) $timeout(function () {
          angular.element('input#package_search').focus();
        });
      };

      $scope.selectAll = function (activePackage) {
        if (activePackage._PrivateData.selectedAsset.length !== activePackage._PrivateData.assets.length) {
          activePackage._PrivateData.selectedAsset = [];

          activePackage._PrivateData.assets.forEach(function (asset) {
            if (!asset._PrivateData) asset._PrivateData = {};
            asset._PrivateData.isSelected = true;
            activePackage._PrivateData.selectedAsset.push(asset);
          });
        } else {
          activePackage._PrivateData.assets.forEach(function (asset) {
            asset._PrivateData.isSelected = false;
          });
          activePackage._PrivateData.selectedAsset = [];
        }
      };

      $scope.selectPackage = function (asset) {
        $scope.activePackage = {};

        var selectedParams = {};
        $scope.loading = true;
        $rootScope.showLinearProgress('#packageLoader');
        $location.search('package_id', asset.id);

        selectedParams['id[eq]'] = asset.id;
        selectedParams['$expand'] = 'resources(url),categories,groups';
        AssetResource.get(selectedParams).$promise
          .then(function (result) {
            if (result.length) {
              $scope.activePackage = processAsset(result[0]);

              PackageService.GetPackageAssets(asset.id)
                  .then(function (collection) {
                    var assetMap = {};
                    for (var i = 0; i < collection.length; i += 1) {
                      assetMap[collection[i].id] = collection[i];
                    }

                    AssetResource.getPackageAssets({id: asset.id}).$promise
                        .then(function (assets) {
                          var orderedAssets = [];
                          for (var i = 0; i < assets.length; i += 1) {
                            if (assetMap.hasOwnProperty(assets[i].id)) {
                              orderedAssets.push(assetMap[assets[i].id]);
                            }
                          }
                          $scope.activePackage.packageAssets = assets;
                          $scope.activePackage._PrivateData.assets = orderedAssets;
                          $scope.loading = false;
                          $rootScope.hideLinearProgress('#packageLoader');
                        })
                        .catch(function (reason) {
                          $rootScope.debugInfo(reason, 'silent');
                          $scope.activePackage._PrivateData.assets = collection;
                          $scope.loading = false;
                          $rootScope.hideLinearProgress('#packageLoader');
                        });
                  })
                  .catch(function (reason) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#packageLoader');
                    $rootScope.debugInfo(reason, 'silent');
                    ToastService.Small({
                      title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                      color: 'amber',
                      icon: 'server-off',
                      blocked: true
                    }, 1000 * 3);
                  });

            } else {
              $location.search('package_id', null);
              $scope.loading = false;
              $rootScope.hideLinearProgress('#packageLoader');
            }
          })
          .catch(function (reason) {
            $location.search('package_id', null);
            $scope.loading = false;
            $rootScope.hideLinearProgress('#packageLoader');
            $rootScope.debugInfo(reason, 'silent');
            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 3);
          });

        AssetService.GetAssetById(asset.id)
            .then(function (assets) {
              var a = assets[0];
              for (var i = 0; i < a.offers.length; i += 1) {
                var offer = a.offers[i];
                if (offer.type === 'free') {
                  $scope.activePackage.free = true;
                  break;
                }
              }
              if ($scope.activePackage.free) {
                $scope.activePackage.billingType = 'free';
              }

              SubscriptionPlanResource.get({'$expand': 'assets'}).$promise
                    .then(function (plans) {
                      var planList = [];
                      for (var i = 0; i < plans.length; i++) {
                        var p = plans[i];
                        var assets = p.assets || [];
                        var processed = {
                          id: p.id,
                          title: p.name,
                          assets: assets
                        };
                        planList.push(processed);
                        for (var j = 0; j < assets.length; j++) {
                          if (assets[j].id === $scope.activePackage.id) {
                            $scope.activePackage.billingType = 'plans';
                            $scope.activePackage.plans.push(processed);
                            break;
                          }
                        }
                        savedPlans = angular.copy($scope.activePackage.plans);
                      }
                      $scope.plans = planList;
                    })
                    .catch(function (reason) {
                      $rootScope.debugInfo(reason, 'silent');
                    });

              $scope.loading = false;
              $rootScope.hideLinearProgress('#packageLoader');
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason, 'silent');
              $scope.loading = false;
              $rootScope.hideLinearProgress('#packageLoader');
            });
      };

      $scope.reorderContent = function() {
        $scope.loading = true;
        $rootScope.showLinearProgress('#modalLoader');

        $scope.reorderedList = angular.copy($scope.activePackage.packageAssets);

        var inner = $templateCache.get('reorder-package-assets.tpl.html');
        inner = $compile(inner)($scope);

        var assetMap = {};
        for (var i = 0; i < $scope.activePackage._PrivateData.assets.length; i += 1) {
          assetMap[$scope.activePackage._PrivateData.assets[i].id] = $scope.activePackage._PrivateData.assets[i];
        }

        $scope.window = ModalWindowService.Open({
          content: inner,
          clear: true,
          isFixed: true,
          keyboard: true,
          actions: [
            {
              title: 'Update',
              color: 'green',
              fn: function () {
                $scope.loading = true;
                $rootScope.showLinearProgress('#packageLoader');

                AssetResource.setPackageAssets({id: $scope.activePackage.id}, $scope.reorderedList).$promise
                    .then(function () {
                      var orderedAssets = [];
                      for (var i = 0; i < $scope.reorderedList.length; i += 1) {
                        if (assetMap.hasOwnProperty($scope.reorderedList[i].id)) {
                          orderedAssets.push(assetMap[$scope.reorderedList[i].id]);
                        }
                      }
                      $scope.activePackage.packageAssets = $scope.reorderedList;
                      $scope.activePackage._PrivateData.assets = orderedAssets;
                      ToastService.Small({
                        title: 'The package content has been reordered',
                        color: 'green',
                        icon: 'check'
                      });
                      $scope.loading = false;
                      $rootScope.hideLinearProgress('#modalLoader');
                      $rootScope.hideLinearProgress('#packageLoader');
                    })
                    .catch(function (reason) {
                      $rootScope.debugInfo(reason, 'silent');
                      ToastService.Small({
                        title: 'Failed to reorder the package content',
                        color: 'red',
                        icon: 'server-minus'
                      });
                      $scope.loading = false;
                      $rootScope.hideLinearProgress('#modalLoader');
                      $rootScope.hideLinearProgress('#packageLoader');
                    });
              }
            },
            {
              title: 'Cancel',
              color: 'red',
              fn: function () {
                $rootScope.hideLinearProgress('#modalLoader');
              }
            }
          ],
          size: {
            s: 12,
            l: 8
          }
        });
      };

      $scope.setActivePackage = function (pkg) {
        $scope.selectPackage(pkg);
      };

      $scope.clearActivePackage = function () {

        $scope.activePackage = {};
        $location.search('package_id', null);
      };

      $scope.isActivePackage = function (pkg) {
        return $scope.activePackage.id === pkg.id;
      };

      $scope.getPackages = function () {
        $scope.loading = true;
        $rootScope.showLinearProgress('#packageLoader');

        PackageService.GetPackages()
          .then(function (collection) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#packageLoader');

            $scope.packageCollection = collection.map(function (item, index) {
              return _parsePackage(item, index);
            });

            if ($scope.packageCollection.length && $scope.routePackageId) {
              var pkg = _.find($scope.packageCollection, {id: $scope.routePackageId});

              if (pkg) {
                $scope.selectPackage(pkg);
              }
            }
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#packageLoader');
            $rootScope.debugInfo(reason, 'silent');
            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 3);
          });
      };

      $scope.removeAssetsFromPackage = function (pkg) {
        if ($scope.loading) return;
        $scope.loading = true;
        $rootScope.showLinearProgress('#packageLoader');

        var _ids = pkg._PrivateData.selectedAsset.map(function (asset) {
          return asset.id;
        });

        PackageService.RemoveAsset([pkg.id], _ids)
          .then(function () {
            $scope.getPackages({index: pkg._PrivateData.index});
            ToastService.Small({
              title: 'Asset(s) successfully removed',
              color: 'green',
              icon: 'package-up'
            }, 1000 * 3);
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.debugInfo(reason);
          });
      };

      var isAssetValid = function() {
        $scope.packageValidateErrors = {};

        var valid = true;
        if (!_.trim($scope.activePackage.name)) {
          $scope.packageValidateErrors.name = true;
          valid = false;
        }
        return valid;
      };

      var normPackageToJson = function(package) {
        var processed = {
          type: 'package',
          name: _.trim(package.name),
          description: _.trim(package.description),
          categories: package.categories,
          rotation_start: package.rotationStart.format(),
          rotation_finish: package.rotationFinish.format(),
          resources: [],
          groups: package.groups,
          free: false,
          plans: []
        };
        if (package.isNew) {
          processed.ext_id = 'package:' + package.name + ':' + CryptoJS.MD5(package.name).toString(CryptoJS.enc.Hex);
        }
        if (package.poster.source) {
          processed.resources.push({
            type: 'picture',
            category: 'poster_blueprint',
            group_id: 'picture',
            source: package.poster.source,
            preparer: 'passthrough',
            deployer: 'origin'
          });
        }
        if (package.billingType === 'free') {
          processed.free = true;
          processed.plans = [];
        }
        if (package.billingType === 'plans') {
          processed.plans = package.plans;
        }
        return processed;
      };

      var comparePlans = function(updated) {
        var diff = {
          add: {},
          delete: {}
        };

        var sourcePlanMap = {};
        for (var i = 0; i < savedPlans.length; i++) {
          sourcePlanMap[savedPlans[i].id] = true;
        }

        for (var i = 0; i < updated.plans.length; i++) {
          var key = updated.plans[i].id;
          if (sourcePlanMap.hasOwnProperty(key)) {
            delete sourcePlanMap[key];
          } else {
            diff.add[key] = true;
          }
        }
        for (var key in sourcePlanMap) {
          diff.delete[key] = true;
        }
        return diff;
      };

      $scope.savePackage = function (pkg) {
        if ($scope.loading) return;

        if (!isAssetValid()) return;

        $scope.loading = true;
        $rootScope.showLinearProgress('#packageLoader');

        var updated = normPackageToJson($scope.activePackage);

        if (pkg.isNew) {
          AssetResource.create(updated).$promise
              .then(function (response) {
                if ($scope.activePackage.plans.length > 0) {
                  for (var i = 0; i < $scope.activePackage.plans.length; i++) {
                    var assets = $scope.activePackage.plans[i].assets;
                    assets.push({id: response.data.id});
                    SubscriptionPlanResource.update({id: $scope.activePackage.plans[i].id}, {assets: assets}).$promise
                        .then(function (response) {
                        })
                        .catch(function (reason) {
                          $rootScope.debugInfo(reason, 'silent');
                        });
                  }
                }
                $scope.loading = false;
                $rootScope.hideLinearProgress('#packageLoader');
                ToastService.Small({
                  title: 'Package successfully created',
                  color: 'green',
                  icon: 'cloud-check'
                }, 1000 * 3);
                $scope.clearActivePackage();
                $rootScope.$broadcast($rootScope.EVENTS.UPDATE_PACKAGE_COLLECTION);
              })
              .catch(function (reason) {
                $scope.loading = false;
                $rootScope.hideLinearProgress('#packageLoader');
                $rootScope.debugInfo(reason, 'silent');
                ToastService.Small({
                  title: 'Package create failed',
                  color: 'red',
                  icon: 'cloud-outline-off'
                }, 1000 * 3);

                $scope.clearActivePackage();
              });
        } else {
          AssetResource.update({id: $scope.activePackage.id}, updated).$promise
              .then(function (response) {
                var planDiff = comparePlans(updated);

                for (var i = 0; i < $scope.plans.length; i++) {
                  var plan = $scope.plans[i];
                  var assets = angular.copy(plan.assets);
                  if (planDiff.add.hasOwnProperty(plan.id)) {
                    assets.push({id: $scope.activePackage.id});
                    SubscriptionPlanResource.update({id: plan.id}, {assets: assets}).$promise
                        .then(function (response) {})
                        .catch(function (reason) {
                          $rootScope.debugInfo(reason, 'silent');
                        });
                  }
                  if (planDiff.delete.hasOwnProperty(plan.id)) {
                    var newList = [];
                    for (var j = 0; j < assets.length; j++) {
                      if (assets[j].id !== $scope.activePackage.id) {
                        newList.push({id: assets[j].id});
                      }
                    }
                    SubscriptionPlanResource.update({id: plan.id}, {assets: newList}).$promise
                        .then(function (response) {})
                        .catch(function (reason) {
                          $rootScope.debugInfo(reason, 'silent');
                        });
                  }
                }

                ToastService.Small({
                  title: 'Package successfully updated',
                  color: 'green',
                  icon: 'cloud-check'
                }, 1000 * 3);

                $rootScope.hideLinearProgress('#packageLoader');
                $scope.loading = false;
              })
              .catch(function (reason) {
                $rootScope.hideLinearProgress('#packageLoader');
                $scope.loading = false;
                $rootScope.debugInfo(reason, 'silent');
                ToastService.Small({
                  title: 'Package update failed',
                  color: 'red',
                  icon: 'cloud-outline-off'
                }, 1000 * 3);
              });
        }
      };

      $scope.createNewPackage = function () {
        $scope.activePackage = {};

        $scope.activePackage.isNew = true;

        $rootScope.hideLinearProgress('#activePackageLoader');

        $scope.activePackage.index = -1;
        $scope.activePackage.extid = '';
        $scope.activePackage.name = '';
        $scope.activePackage.description = '';
        $scope.activePackage.rotationStart = moment.utc();
        $scope.activePackage.rotationFinish = moment.utc();

        $scope.activePackage.categories = [];
        $scope.activePackage.assets = [];
        $scope.activePackage.groups = [];
        $scope.activePackage.plans = [];
        $scope.activePackage.free = true;
        $scope.activePackage.billingType = 'free';

        $scope.activePackage.poster = {
          state: '',
          url: '',
          source: ''
        };

        $scope.activePackage._PrivateData = {};
        $scope.activePackage._PrivateData.offset = 0;
        $scope.activePackage._PrivateData.limit = 30;
        $scope.activePackage._PrivateData.selectedAsset = [];
      };

      $scope.deletePackage = function (pkg, event) {
        if (event && event.stopPropagation) event.stopPropagation();
        if (event && event.preventDefault) event.preventDefault();

        if ($scope.loading) return;

        ModalConfirmService.Open({
          content: '<p class="fs-headline tc-red-800"> Delete </p> <p class="fs-title">This action will delete content permanently. ' +
          'Are You sure? </p>',
          action: {
            title: 'Delete',
            fn: function () {
              $scope.loading = true;
              $rootScope.showLinearProgress('#activePackageLoader');

              AssetService.DeleteAsset(pkg)
                .then(function (response) {
                  $scope.loading = false;
                  $rootScope.hideLinearProgress('#activePackageLoader');
                  ToastService.Small({
                    title: 'Package: <b class="tc-white"> ' + pkg.title + '</b> successfully deleted',
                    color: 'green',
                    icon: 'delete'
                  }, 1000 * 3);
                  $rootScope.$broadcast($rootScope.EVENTS.UPDATE_PACKAGE_COLLECTION);
                  $scope.clearActivePackage();
                })
                .catch(function () {
                  $scope.loading = false;
                  $rootScope.hideLinearProgress('#activePackageLoader');
                  $rootScope.debugInfo(reason);
                  ToastService.Small({
                    title: 'Package: <b class="tc-white"> ' + pkg.title + '</b> delete failed',
                    color: 'red',
                    icon: 'delete'
                  }, 1000 * 3);
                });
            }
          }
        });
      };

      $scope.manageAssetsFromPackage = function (toAdd, toRemove, toThis) {
        if ($scope.loading) return;

        $rootScope.showLinearProgress('#modalLoader');
        $scope.loading = true;

        var allQ = {};

        if (toAdd.length) {
          var addIds = toAdd.map(function (asset) {
            return asset.id;
          });

          allQ.add = PackageService.AddAsset([toThis.id], addIds);
        }

        if (toRemove.length) {
          var removeIds = toRemove.map(function (asset) {
            return asset.id;
          });

          allQ.remove = PackageService.RemoveAsset([toThis.id], removeIds);
        }

        return allQ;
      };

      $scope.openModal = function (pkg) {
        if ($scope.loading) return;

        if (!pkg.isNew) {

          ManageAssetsWindow.OpenManageAssetsWindow({
            manageAssetsFn: $scope.manageAssetsFromPackage,
            obj: pkg,
            index: pkg._PrivateData.index,
            currentCollection: _.map(pkg._PrivateData.assets, 'id'),
            data: 'package',
            title: pkg.title,
            filter: {
              packages: true
            }
          })

        } else {
          ToastService.Small({
            title: 'You should create Package first',
            color: 'amber',
            icon: 'alert'
          }, 1000 * 3);
        }
      };

      if (!$rootScope.$$listeners[$rootScope.EVENTS.UPDATE_PACKAGE_COLLECTION] || !$rootScope.$$listeners[$rootScope.EVENTS.UPDATE_PACKAGE_COLLECTION].length) {
        $rootScope.$on($rootScope.EVENTS.UPDATE_PACKAGE_COLLECTION, function (event) {
          $scope.getPackages();
        });
      }

      angular.element('#package_data').css({
        height: angular.element(window).height() + angular.element(window).scrollTop()
      });

      $scope.routePackageId = null;
      if ($routeParams.package_id) {
        $scope.routePackageId = Number($routeParams.package_id);
      }

      $scope.$on('$routeUpdate', function () {
        if ($scope.routePackageId && !$routeParams.package_id) {
          $scope.clearActivePackage();
        }
        $scope.routePackageId = Number($routeParams.package_id) || '';
      });

      $rootScope.$broadcast($rootScope.EVENTS.UPDATE_PACKAGE_COLLECTION);

      $scope.$on('$destroy', function () {
        $rootScope.$$listeners[$rootScope.EVENTS.UPDATE_PACKAGE_COLLECTION] = [];
        $scope.groupWatcher();
      });
    }]);
